<template>
    <Login v-if="$route.path === '/login'" />
    <OAuth v-else-if="$route.path === '/oauth/redirect'" />
    <Landing v-else-if="$route.path === '/landing'" />
    <App :theme="theme" :layout="layout" @theme-change="onThemeChange" @layout-change="onLayoutChange" v-else />
</template>

<script>
    import App from './App.vue';
    import Login from './pages/Login';
    import Landing from './pages/Landing';
    import OAuth from './pages/OAuth';

	export default {
        data() {
            return {
                theme: 'blue',
                layout: 'layout-blue'
            }
        },
        methods: {
            onThemeChange(theme) {
                this.theme = theme;
            },
            onLayoutChange(layout) {
                this.layout = layout;
            }
        },
        components: {
            "App": App,
            "Login": Login,
            "Landing": Landing,
            "OAuth": OAuth,
        }
	}
</script>

<style scoped>
</style>
